/**
 * @description
 * @export
 * @class API
 */
export default class PlompClient {
  /**
   * Creates an instance of API.
   * @param {string} [baseUrl=""]
   * @memberof API
   */
  constructor(baseUrl = "", apiKey = "", lang = "en-ca") {
    this.baseUrl = baseUrl;
    this.defaultHeaders = {
      "Content-Type": "application/json",
      "X-API-Key": apiKey,
      Accept: "application/json",
      "Accept-Language": lang,
    };
  }

  async request(url, options = {}) {
    const mergedOptions = {
      ...options,
      headers: {
        ...this.defaultHeaders,
        ...options.headers,
      },
    };

    const response = await fetch(`${this.baseUrl}${url}`, mergedOptions);

    let errorMessage = "Unknown error";
    if (!response.ok) {
      switch (response.status) {
        case 400:
          errorMessage = "Bad request";
          break;
        case 401:
          errorMessage = "Unauthorized";
          window.location.href = "/";
          break;
        case 403:
          errorMessage = "Forbidden";
          window.location.href = "/";
          break;
        case 404:
          errorMessage = "Not found";
          break;
        case 500:
          errorMessage = "Internal server error";
          break;
        default:
          errorMessage = "Unknown error";
      }
    }

    if (response.status !== 204) {
      // 204 No Content responses should not be parsed.
      return await response.json();
    } else {
      return null; // Return null for 204 responses.
    }
  }

  async get(url, headers = {}) {
    return this.request(url, { method: "GET", headers });
  }

  async post(url, data = {}, headers = {}) {
    return this.request(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers,
    });
  }

  async put(url, data = {}, headers = {}) {
    return this.request(url, {
      method: "PUT",
      body: JSON.stringify(data),
      headers,
    });
  }

  async patch(url, data = {}, headers = {}) {
    return this.request(url, {
      method: "PATCH",
      body: JSON.stringify(data),
      headers,
    });
  }

  async delete(url, data = {}, headers = {}) {
    return this.request(url, {
      method: "DELETE",
      body: JSON.stringify(data),
      headers,
    });
  }

  // async delete(url, headers = {}) {
  //   return this.request(url, { method: "DELETE", headers });
  // }

  getVersion() {
    return this.get("/version");
  }

  createCart(cartData) {
    return this.post("/carts", cartData);
  }

  getInvoices() {
    return this.get("/invoices");
  }

  getInvoice(invoiceNumber) {
    return this.get(`/invoices/${invoiceNumber}`);
  }

  sendInvoiceEmail(invoiceNumber) {
    return this.post(`/invoices/${invoiceNumber}/send`);
  }

  payInvoice(invoiceNumber) {
    return this.put(`/invoices/${invoiceNumber}/status`, { status: "PAYMENT_RECEIVED" });
  }

  reconcileInvoice(invoiceNumber) {
    return this.put(`/invoices/${invoiceNumber}/status`, { status: "INVOICE_RECONCILED" });
  }

  revokeAllCodes(invoiceNumber) {
    return this.delete(`/invoices/${invoiceNumber}/accesscodes`);
  }

  deleteInvoice(invoiceNumber) {
    return new Error(501, "Not implemented");
  }

  handleStripeWebhook(webhookData) {
    return this.post("/webhooks/stripe", webhookData);
  }
}
